/**
 * Detail Tokens
 *
 * Mode-agnostic primitive tokens for sizing, spacing, and corner radius.
 * Sourced from Figma root export — these don't change between light and dark mode.
 *
 * Used by component-tokens.ts for `*.details.*` keys (asset sizes, paddings,
 * corner radii, heights, dividers, etc.).
 */

export const detailTokens = {
  spacing: {
    padding: {
      zero: '0px',
      '4xs': '2px',
      '3xs': '4px',
      '2xs': '6px',
      xs: '8px',
      sm: '12px',
      base: '16px',
      lg: '20px',
      xl: '24px',
      '2xl': '32px',
      '3xl': '40px',
      '4xl': '48px',
      '5xl': '56px',
      '6xl': '64px',
      '7xl': '72px',
      '8xl': '80px',
    },
    spaceBetween: {
      zero: '0px',
      '3xs': '2px',
      '2xs': '4px',
      xs: '8px',
      sm: '12px',
      base: '16px',
      lg: '20px',
      xl: '24px',
      '2xl': '32px',
      '3xl': '40px',
      '4xl': '80px',
    },
    layoutGrid: {
      horizontalBase: '24px',
      verticalHorizontal: '24px',
    },
  },
  sizing: {
    dividers: {
      // 'seconary' typo preserved from Figma export — do not rename without coordinating with design.
      details: {
        base: '1px',
        seconary: '2px',
        tertiary: '4px',
      },
    },
    asset: {
      '3xs': '8px',
      '2xs': '10px',
      xs: '12px',
      sm: '16px',
      mdBase: '18px',
      lg: '24px',
      xl: '32px',
      '2xl': '40px',
      '3xl': '48px',
      '4xl': '80px',
    },
    sizeTokens: {
      '4xs': '16px',
      '3xs': '20px',
      '2xs': '24px',
      xs: '28px',
      sm: '32px',
      base: '40px',
      lg: '48px',
      xl: '56px',
      '2xl': '72px',
      '3xl': '80px',
      '4xl': '100px',
      '5xl': '256px',
      '6xl': '320px',
    },
  },
  cornerRadius: {
    primary: '6px',
    lg: '12px',
    sm: '4px',
    xs: '2px',
    pill: '100px',
    sharp: '0px',
  },
} as const;

export type DetailTokens = typeof detailTokens;
